module.exports = __webpack_public_path__ + "img/4.d65b893d.jpg";